import React from 'react';
import { styled } from '@linaria/react';
interface Props {
  name?: string;
  /** This indicates the margin at the top when scrolling to the component.
   *  Only useful if you have a fixed header, in which case this value
   *  should be the height of the header.
   */
  scrollTopMargin?: number;
  as?: React.ElementType;
  id?: string;
  children: React.ReactNode;
  dataId?: string;
}
const _exp = /*#__PURE__*/() => ({
  scrollTopMargin
}) => scrollTopMargin;
const StyledSection = /*#__PURE__*/styled('div')({
  name: "StyledSection",
  class: "s1hunydd",
  propsAsIs: false,
  vars: {
    "s1hunydd-0": [_exp(), "px"]
  }
});
export const ScrollSection: React.FC<Props> = ({
  name,
  children,
  scrollTopMargin,
  as = 'section',
  id,
  dataId
}) => <StyledSection scrollTopMargin={scrollTopMargin} data-scrollname={name} as={as} id={id} data-id={dataId}>
    {children}
  </StyledSection>;

require("./ScrollSpy.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ScrollSpy.tsx");